import { Button } from "@/components/ui/button";
import type { PageResponse } from "@/types/api";

interface Props<T> {
    page: PageResponse<T>;
    pageSize: number;
    currentPage: number;
    onPage: (next: number) => void;
}

export function Pagination<T>({ page, pageSize, currentPage, onPage }: Props<T>): React.ReactNode {
    if (page.totalPages <= 1) return null;
    const from = page.number * pageSize + 1;
    const to = page.number * pageSize + page.content.length;
    return (
        <div className="flex items-center justify-between px-1 py-3 text-xs text-muted-foreground">
            <span>
                {from}–{to} of {page.totalElements}
            </span>
            <div className="flex gap-2">
                <Button
                    size="sm"
                    variant="outline"
                    onClick={() => onPage(Math.max(0, currentPage - 1))}
                    disabled={page.first}
                    data-testid="pagination-prev"
                >
                    Previous
                </Button>
                <span className="px-2 self-center">
                    Page {page.number + 1} of {page.totalPages}
                </span>
                <Button
                    size="sm"
                    variant="outline"
                    onClick={() => onPage(currentPage + 1)}
                    disabled={page.last}
                    data-testid="pagination-next"
                >
                    Next
                </Button>
            </div>
        </div>
    );
}
